import React from 'react';
import { FiEdit3 } from 'react-icons/fi';
import { TbMessageCircle } from 'react-icons/tb';

/** Chat-only product route (cluster 2). Social + chat stays on /sm/all-messages. */
export const MESSAGES_APP_BASE = '/messages';

export const MESSAGES_SIDEBAR_ITEMS = [
  {
    key: 'messages-inbox',
    label: 'Inbox',
    path: MESSAGES_APP_BASE,
    isActive: (pathname) => pathname === MESSAGES_APP_BASE || pathname.startsWith(`${MESSAGES_APP_BASE}/`),
    icon: <TbMessageCircle aria-hidden />,
  },
  {
    key: 'messages-compose',
    label: 'New message',
    path: `${MESSAGES_APP_BASE}?compose=1`,
    icon: <FiEdit3 aria-hidden />,
  },
];
